// extracted by mini-css-extract-plugin
module.exports = {"btn":"tooltip-cell-button_btn__NFRjU","btnText":"tooltip-cell-button_btnText__1b_yu"};